import type { VerticalNavItems } from '@layouts/types'

import vector from './vector'

// Array of sections
export default [
  ...vector,
] as VerticalNavItems
